/**
 * Schema of SLa Holiday
 * @author Thacryba
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import SlaFeriado from '@/model/resource/SlaFeriado'
import moment from 'moment'

export default (model: SlaFeriado): Schema => ({
  idSlaFeriadoPk: {
    content: model.idSlaFeriadoPk,
    editable: false,
  },

  dia: {
    content: model.dia,
  },

  date: {
    content: moment(model.date).format('DD/MM'),
  },

  mes: {
    content: model.mes,
  },

  desc: {
    content: model.desc.toUpperCase(),
    textContent: null,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '50',
    },
  },

  ativo: {
    content: bool(model.ativo),
    input: InputType.CHECKBOX,
  },
})
